<template>
  <!-- 单独的一张图片，仅显示 -->
  <div class="alone-image" :style="{'--image-height': height}">
    <img v-if="src" :src="src" alt="" class="image" :style="{'object-fit': objectFit}"/>
    <img v-else src="@/assets/image/picture.svg" class="image placeholder" alt=""/>
  </div>
</template>

<script>



export default {
  props: {
    src: {default: ""},
    objectFit: {default: "cover"},
    height: {default: "100%"}
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.alone-image{
  width: 100%;
  height: var(--image-height);
  .image{
    width: 100%;
    height: var(--image-height);
    border: 1px solid var(--yq-border-color);
    object-fit: contain;
    display: block;
    &.placeholder{
      opacity: .3;
    }
  }
}
</style>